import React from 'react';
import { motion, useInView } from 'framer-motion';
import { useRef } from 'react';

const textVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: "easeOut" } }
};

const buttonVariants = {
  hidden: { opacity: 0, scale: 0.8 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.5 } },
  hover: { scale: 1.05, transition: { duration: 0.3 } }
};

const imageVariants = {
  hidden: { opacity: 0, x: 100 },
  visible: { opacity: 1, x: 0, transition: { duration: 0.8, ease: "easeOut" } }
};

export default function Hero() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  const handleScroll = () => {
    const cardsSection = document.querySelector('.bg-gray-100');
    if (cardsSection) {
      cardsSection.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <motion.div 
      ref={ref}
      className="flex flex-col lg:flex-row min-h-screen"
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
    >
      <div className="flex flex-wrap gap-5 justify-between w-full lg:w-1/2 text-zinc-900 p-8 lg:p-16">
        <div className="flex flex-col items-start my-auto w-full">
   
          <motion.h1 
            className="text-4xl lg:text-5xl font-bold leading-tight mb-4 text-zinc-800 drop-shadow-md"
            variants={textVariants}
          >
            <span className="text-green-600">Play, Connect and Thrive.</span> App you parents want on your phone!
          </motion.h1>
          <motion.p 
            className="text-base lg:text-lg font-medium leading-relaxed mb-6 text-zinc-700"
            variants={textVariants}
          >
            Welcome to Fisiko- Your sport super app that together everyone who enjoys sport. Be it playing, coaching, watching or tracking. Post your favorite sports moments, arrange matches, and share the excitement with your friends. Whether you're organizing a local game or celebrating a big win, Fisiko connects you with the sports community like never before. Game on! 
          </motion.p>
          <motion.button 
            className="px-8 py-4 text-base font-bold tracking-wide text-center text-white uppercase bg-green-600 rounded-full hover:bg-green-700 transition-colors duration-300 shadow-lg hover:shadow-xl"
            variants={buttonVariants}
            whileHover="hover"
            whileTap={{ scale: 0.95 }}
            onClick={handleScroll}
          >
            Learn More
          </motion.button>
        </div>
      </div>
      <motion.div 
        className='w-full lg:w-1/2 p-4 mt-8 lg:mt-0'
        variants={imageVariants}
      >
        <motion.img
          className="w-full h-full object-contain"
          loading="lazy"
          src="images/Hero-image-transformed.png"
          alt="Two boys playing sports"
          whileHover={{ scale: 1.05 }}
          transition={{ duration: 0.3 }}
        />
      </motion.div>
    </motion.div>
  );
}